import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import {
  ActivationCodeGuard,
  AuthGuard,
  AuthRedirectGuard,
  EmailValidatorGuard,
  purchaseThanksStr,
  RestrictDefaultPasswordChangeGuard,
  trialActiveStr,
} from '@piqet-angular/shared';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { PurchaseThanksComponent } from './purchase-thanks/purchase-thanks.component';
import { PurchaseCancelComponent } from './purchase-cancel/purchase-cancel.component';
import { ForceChangePasswordComponent } from './force-change-password/force-change-password.component';
import { NotFoundComponent } from 'libs/ui/src/lib/not-found/not-found.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { LcaDocComponent } from './docs/lca-doc/lca-doc.component';
import { QuickReferenceComponent } from './docs/quick-reference/quick-reference.component';
import { AuthApiDocComponent } from './docs/auth-api-doc/auth-api-doc.component';

const routes: Routes = [
  {
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent,
    canActivate: [AuthRedirectGuard],
  },
  {
    path: 'forgot-password',
    pathMatch: 'full',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    pathMatch: 'full',
    component: ResetPasswordComponent,
  },
  {
    path: 'activate-user',
    pathMatch: 'full',
    component: ActivateUserComponent,
    canActivate: [ActivationCodeGuard],
  },
  {
    path: 'register',
    pathMatch: 'full',
    component: RegisterComponent,
    canActivate: [AuthRedirectGuard],
  },
  {
    path: 'create-user/:id',
    pathMatch: 'full',
    component: CreateUserComponent,
  },
  {
    path: 'PurchaseLicense/PLicense',
    pathMatch: 'full',
    redirectTo: 'register',
  },
  {
    path: 'register/freeTrial',
    pathMatch: 'full',
    component: RegisterComponent,
    canActivate: [AuthRedirectGuard],
  },
  {
    path: purchaseThanksStr,
    pathMatch: 'full',
    component: PurchaseThanksComponent,
    canActivate: [EmailValidatorGuard],
  },
  {
    path: trialActiveStr,
    pathMatch: 'full',
    component: PurchaseThanksComponent,
    canActivate: [EmailValidatorGuard],
  },
  {
    path: 'purchase-cancel',
    pathMatch: 'full',
    component: PurchaseCancelComponent,
  },
  {
    path: 'secure-password',
    pathMatch: 'full',
    component: ForceChangePasswordComponent,
    canActivate: [RestrictDefaultPasswordChangeGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'unauthorized',
    component: NotFoundComponent,
  },
  {
    path: 'forbidden',
    component: NotFoundComponent,
  },
  {
    path: 'docs',
    redirectTo: 'docs/lca-api',
    pathMatch: 'full',
  },
  {
    path: 'docs/lca-api',
    component: LcaDocComponent,
  },
  {
    path: 'docs/quick-reference',
    component: QuickReferenceComponent,
  },
  {
    path: 'docs/lca-api/auth',
    component: AuthApiDocComponent,
  },
  {
    path: 'LcaDocComponent',
    component: NotFoundComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard, AuthRedirectGuard],
})
export class FeaturesRoutingModule {}
